import httpClient from '../httpClient';

export async function getAllFornecedores() {
  try {
    const response = await httpClient.get(`/api/fornecedor`);
    return Array.isArray(response.data.fornecedores)
      ? response.data.fornecedores
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Fornecedores: ' + error);
  }
}

export async function getFornecedor(fornecedorID: string) {
  try {
    const response = await httpClient.get(`/api/fornecedor/${fornecedorID}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Fornecedor: ' + error);
  }
}

export async function getAllCnpjCnaes() {
  try {
    const response = await httpClient.get(`/api/cnpjcnae`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de CNPJCNAE: ' + error);
  }
}

export async function getAllNaturezasjuridicas() {
  try {
    const response = await httpClient.get(`/api/naturezajuridica`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Naturezas Jurídicas: ' + error);
  }
}

export async function getAllMunicipiosIbge() {
  try {
    const response = await httpClient.get(`/api/municipioibge`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Municípios IBGE: ' + error);
  }
}

export async function getUsuarioInterface(params: {
  id?: string;
  nuInterfaceSisaf?: string;
  usuarioVinculacaoId?: string;
  cnpj?: string;
}) {
  try {
    const response = await httpClient.get(`/api/usuariointerface`, {
      params,
    });

    if (!response.data?.relacoes || !Array.isArray(response.data.relacoes)) {
      throw new Error('Estrutura de dados inválida na resposta da API');
    }

    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter relações de usuário: ' + error);
  }
}

export async function getAllFornecedoresSimplificado() {
  try {
    const response = await httpClient.get(`/api/fornecedor/simplificado`);
    return Array.isArray(response.data.fornecedores)
      ? response.data.fornecedores
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Fornecedores: ' + error);
  }
}
